<template>
	<v-dialog v-model="dialog" max-width="600">
		<template v-slot:activator="{ on, attrs }">
			<v-btn color="secondary" class="mt-4" v-bind="attrs" v-on="on">
				<v-icon class="mr-1">mdi-plus</v-icon>
				項目を追加
			</v-btn>
		</template>

		<v-card>
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white" class="color-white"> 項目追加 </v-toolbar-title>
				<v-spacer />
				<v-btn icon dark @click="dialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<div class="pa-2">
				<v-form ref="form" v-model="valid">
					<v-select
						v-model="processType"
						:rules="[rules.required]"
						class="mt-4"
						label="項目名選択"
						:items="construction_process_types"
						dense
						outlined
					/>
					<v-text-field v-model="sub_name" class="mt-4" label="項目サブネーム" dense outlined />
				</v-form>
				<v-row no-gutters class="mt-4">
					<v-col sm="3" cols="0" />
					<v-col sm="6" cols="12" class="text-center">
						<v-btn color="secondary" :disabled="!valid" @click="addProcess">
							<v-icon class="mr-1">mdi-plus</v-icon>
							追加する
						</v-btn>
					</v-col>
					<v-col sm="3" cols="0" class="text-right">
						<v-btn text @click="closeDialog"> キャンセル </v-btn>
					</v-col>
				</v-row>
			</div>
		</v-card>
	</v-dialog>
</template>
<script>
import common from "../../../helper/common"
import rules from "../../../helper/rules"

export default {
	props: {
		construction_process_types: {
			type: Array,
			default: () => {
				return []
			},
		},
	},
	data() {
		return {
			processType: null,
			sub_name: null,
			dialog: false,
			valid: false,
			rules,
			common,
		}
	},
	methods: {
		addProcess() {
			// TODO
			const process = { construction_process_type: this.processType, sub_name: this.sub_name }
			this.$emit("add-process", process)
		},
		closeDialog() {
			this.dialog = false
			this.$refs.form.reset()
		},
	},
}
</script>
